// @flow
import { ErightsActionTypes } from './constants';

type ErightsAction = { type: string, payload: {} | string };

// common success
export const erightApiResponseSuccess = (actionType: string, data: any): ErightsAction => ({
    type: ErightsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const erightApiResponseError = (actionType: string, error: string): ErightsAction => ({
    type: ErightsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const listErights = (): ErightsAction => ({
    type: ErightsActionTypes.LIST_ERIGHTS,
    payload: {},
});
export const getEright = (id: string): ErightsAction => ({
    type: ErightsActionTypes.GET_ERIGHT,
    payload: { id },
});

export const addEright = (eright:any):ErightsAction=>({
    type:ErightsActionTypes.ADD_ERIGHT,
    payload:eright
})
export const updateEright = (eright:any):ErightsAction=>({
    type:ErightsActionTypes.UPDATE_ERIGHT,
    payload:eright
})
export const deleteEright = (id:string):ErightsAction=>({
    type:ErightsActionTypes.DELETE_ERIGHT,
    payload:{id}
})

export const resetEright = (): ErightsAction => ({
    type: ErightsActionTypes.RESET,
    payload: {},
});

